<template>
    <modal id="document-modal"
           v-model="showModal"
           :title="selectedUrl ? $t('edit_document') : $t('add_document')"
           @submit="submitData"
           :loading="loading"
           :preloader="preloader">

        <form ref="form" :data-url="selectedUrl ? selectedUrl : apiUrl.DOCUMENTS">
            <app-form-group
                :label="$t('name')"
                type="text"
                v-model="formData.name"
                :placeholder="$placeholder('name', '')"
                :error-message="$errorMessage(errors, 'name')"
                :options="options"
                :required="true"
            />

            <div class="row">
                <div class="col-md-6">
                    <app-form-group
                        type="date"
                        :label="$t('expired')"
                        v-model="formData.expired"
                        :placeholder="formData.expired ? $placeholder('date') : this.$t('not_added_yet')"
                        :error-message="$errorMessage(errors, 'expired')"
                    />
                </div>
                <div class="col-md-6">
                    <app-form-group
                        type="single-checkbox"
                        :list-value-field="$t('verified')"
                        v-model="formData.verified"
                    />
                </div>
            </div>
            
            <div class="form-group">
                <app-input
                    type="dropzone"
                    v-model="files"
                    :error-message="$errorMessage(errors, 'files.0')"
                />
                <small class="text-muted font-italic mt-3 d-inline-block">
                    {{ $t('document_recommendation') }}
                </small>
            </div>

            <div class="form-group" v-if="current_files.length">
                <label>{{ $t('current_files') }}</label>
                <div class="img-container">
                    <div class="img-box" v-for="(url, index) in current_files" :key="'current-image-' + index">
                        <img v-if="isImage(url)"
                            :src="url"
                            class="img-thumbnail"
                            :title="getFileName(url)"
                        />
                        <div v-else
                            :href="url"
                            target="_blank"
                            class="d-flex align-items-center justify-content-center text-truncate img-thumbnail"
                            :title="getFileName(url)"
                        >
                            <i :class="`fa fa-file-${getFileExtension(url).substring(1)}`"></i>
                        </div>
                        <div class="img-action">
                            <button type="button" class="btn btn-sm btn-primary" @click="viewFile(url)" :title="$t('view')">
                                <i class="fas fa-eye"></i>
                            </button>
                            <button type="button" class="btn btn-sm btn-danger" @click="deleteFile(index)" :title="$t('delete')">
                                <i class="fas fa-trash"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

        </form>
    </modal>
</template>

<script>
import ModalMixin from "../../../../../../common/Mixin/Global/ModalMixin";
import FormHelperMixins from "../../../../../../common/Mixin/Global/FormHelperMixins";
import {formDataAssigner} from "../../../../../../common/Helper/Support/FormHelper";
import {TENANT_BASE_URL} from "../../../../../../common/Config/UrlHelper";
import {axiosGet} from "../../../../../../common/Helper/AxiosHelper";
import * as apiUrl from "../../../../../Config/ApiUrl";
import {formatDateForServer} from "../../../../../../common/Helper/Support/DateTimeHelper";
import HelperMixin from "../../../../../../common/Mixin/Global/HelperMixin";

export default {
    name  : "DocumentCreateEditModal",
    mixins: [ModalMixin, FormHelperMixins, HelperMixin],
    props : {
        userId: {
            required: true
        }
    },
    data() {
        return {
            files   : [],
            options : [],
            current_files: [],
            deleted_files: [],
            formData: {
                verified: false,
                name    : null,
            },
        }
    },
    mounted() {
        axiosGet(apiUrl.DOCUMENTS + '?per_page=-1&user_id=' + window.user.id).then(({data}) => {
            for (const item of data) {
                this.options.push(item.name)
            }
        }).catch(error => {
            this.$toastr.e(error.response.data.message)
        });
    },
    methods: {
        TENANT_BASE_URL() {
            return TENANT_BASE_URL
        },
        submitData() {
            let url      = this.$refs.form.dataset["url"];
            let formData = formDataAssigner(new FormData, this.formData);
            formData.append('user_id', this.userId);

            if (this.selectedUrl) {
                // for file update need to send by post.
                formData.append('_method', 'PATCH');
            }

            if (!this.formData.name) {
                formData.delete('name')
            }

            if (this.formData.expired) {
                formData.set('expired', formatDateForServer(this.formData.expired))
            } else {
                formData.delete('expired')
            }

            this.files.forEach(file => formData.append('files[]', file))
            this.deleted_files.forEach(fileUrl => formData.append('deleted_files[]', fileUrl))
            this.loading = true

            this.submitFromFixin('post', url, formData);
        },
        afterSuccess({data}) {
            this.toastAndReload(data.message, 'documents-table');
            this.formData = {};
            $('#document-modal').modal('hide');
            this.$emit('input', false);
        },
        afterSuccessFromGetEditData({data}) {
            this.formData.verified = data.verified;
            this.formData.name     = data.name;
            this.formData.expired  = data.expired;
            this.files             = [];
            this.preloader         = false;
            this.current_files     = data.path;
        },
    },
}
</script>

<style scoped>
    @media (min-width: 768px) {
        ::v-deep .customized-checkbox {
            margin-top: 42px;
            margin-left: 80px;
        }
    }
</style>